import { ReactNode } from "react";

import styles from "./BoxSection.module.scss";
import BoxSectionList from "./box-section-list";

interface BoxSectionProps {
  title?: ReactNode;
  children: ReactNode;
}

export const BoxSection = ({ title = "", children }: BoxSectionProps) => {
  return (
    <div className={styles.container}>
      {title && <div className={styles.title}>{title}</div>}
      {children}
    </div>
  );
};

BoxSection.List = BoxSectionList;
